import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const MeasurementInfo = ({ infoKey }) => {
    const { t } = useTranslation();
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div className="relative inline-block ml-1">
            <button
                type="button"
                tabIndex="-1"
                className="text-blue-500 hover:text-blue-700 focus:outline-none transition-colors"
                onClick={() => setShowTooltip(!showTooltip)}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
            >
                <svg
                    className="w-4 h-4 inline-block"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    aria-label="Information"
                >
                    <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                    />
                </svg>
            </button>

            {showTooltip && (
                <div className="absolute z-50 w-64 p-3 bg-white border border-gray-300 rounded-lg shadow-lg text-sm text-gray-700 left-0 top-6">
                    <div className="absolute -top-2 left-2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-transparent border-b-white"></div>
                    <div className="absolute -top-2.5 left-2 w-0 h-0 border-l-8 border-r-8 border-b-8 border-transparent border-b-gray-300"></div>
                    {t(`legMeasuring.measurements.${infoKey}`)}
                </div>
            )}
        </div>
    );
};

export default MeasurementInfo;
